const t = (t2) => "string" != typeof t2 ? t2 : t2.replace(/([=$])/g, (t3) => `\\u${t3.charCodeAt(0).toString(16)}`);
export {
  t as sanitizeUserInput
};
//# sourceMappingURL=sanitizeUserInput.js.map
